var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 283,
    viewBox: "0 0 310 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4917_9641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 310,
    height: 283
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 283,
    rx: 15,
    fill: "url(#paint0_radial_4917_9641)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4917_9641)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 31,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 31,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 31,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 31,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 31,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 31,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 31,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 31,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 31,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 31,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 62,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 62,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 62,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 62,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 62,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 62,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 62,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 62,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 62,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 62,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 93,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 93,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 93,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 93,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 93,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 93,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 93,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 93,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 93,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 93,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 124,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 124,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 124,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 124,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 124,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 124,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 124,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 124,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 124,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 124,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 155,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 155,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 155,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 155,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 155,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 155,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 155,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 155,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 155,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 155,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 186,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 186,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 186,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 186,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 186,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 186,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 186,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 186,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 186,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 186,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 217,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 217,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 217,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 217,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 217,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 217,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 217,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 217,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 217,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 217,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 248,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 248,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 248,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 248,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 248,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 248,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 248,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 248,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 248,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 248,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 279,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 279,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 279,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 279,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 279,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 279,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 279,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 279,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 279,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 279,
    width: 31,
    height: 31,
    stroke: "#9AA2B8",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4917_9641",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155 141.5) rotate(90) scale(152.5 167.049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.08
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.91edd2175e19aaf209e321a55dce46c3.svg";
export { ForwardRef as ReactComponent };